import { Component, signal, WritableSignal } from '@angular/core';
import { BlockUl, BlockUlItem } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-ul',
  templateUrl: './block-ul.component.html',
})
export class BlockUlComponent extends BlockAbstractComponent<BlockUl, null> {
  public items: WritableSignal<BlockUlItem[]> = signal([]);

  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(block: BlockUl): void {
    if (Array.isArray(block.data.items)) {
      this.items.set(block.data.items);
    } else {
      this.items.set(Object.values(block.data.items));
    }
  }
}
